/* eslint-disable import/no-extraneous-dependencies */
import 'react-advanced-cropper/dist/style.css'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ImageCropper from '@/shared/components/ImageCropper/ImageCropper'
import Modal from '../Modal'
import { useDiscardConfirmation } from '../ConfirmationModal/useDiscardConfirmation'
import { useCropImageStore } from '@/shared/store/useCropImageStore'
import { useImageSlots } from '@/shared/store/useImageSlots'

function CropImageModal() {
  const { t } = useTranslation()
  const {
    isOpen,
    slotId,
    imageUrl,
    imageShape,
    imageSize,
    stencilSize,
    close
  } = useCropImageStore()

  /*
    A picture picked here and not yet cropped. A click outside closes the
    dialog the way the X does (Modal), and opened over the settings one stray
    click threw the picture's framing away; so it asks first, as the form
    dialogs do. Only for a picture picked in this opening: one that is only
    looked at closes at once.
  */
  const originalUrl = useImageSlots(s =>
    slotId ? (s.slots[slotId]?.originalUrl ?? null) : null
  )
  const [openedWith, setOpenedWith] = useState<string | null>(null)
  useEffect(() => {
    if (isOpen) setOpenedWith(originalUrl)
    // Taken when the dialog opens, not as the picture changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])
  const { requestClose, discardConfirmation } = useDiscardConfirmation(
    isOpen && originalUrl !== openedWith,
    close
  )

  return (
    <>
      <Modal
        title={t('CROP_IMAGE_MODAL.TITLE')}
        size="fit-content"
        isOpen={isOpen}
        onClose={requestClose}
      >
        <ImageCropper
          slotId={slotId!}
          imageSize={imageSize!}
          stencilSize={stencilSize!}
          imageUrl={imageUrl}
          shape={imageShape}
          onModalClose={close}
        />
      </Modal>
      {discardConfirmation}
    </>
  )
}

export default CropImageModal
